import { Component, signal, output, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownItem } from 'src/app/core/models/dropdown.model';

@Component({
  standalone: true,
  selector: 'pagination-layout-1',
  templateUrl: './pagination-layout-1.component.html',
  styleUrls: ['./pagination-layout-1.component.scss'],
  imports: [CommonModule]
})
export class PaginationLayout1Component {


  readonly paginationOptions = input<DropdownItem<number>[] | null>(null);
  readonly currentPageIndex = input<number>(1);

  // Update output to use Angular 20 output() function
  paginationChanged$ = output<number>();

  onPreviousPage() {
    this.paginationChanged$.emit(this.currentPageIndex() - 1);
  }

  onPageClick(pageIndex: number) {
    this.paginationChanged$.emit(pageIndex);
  }

  onNextPage() {
    this.paginationChanged$.emit(this.currentPageIndex() + 1);
  }
}

